import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { translate } from '../../../base/i18n/functions';
import { IconBubble, IconDownload } from '../../../base/icons/svg';
import { SMALL_MOBILE_WIDTH } from '../../../base/responsive-ui/constants';
import Button from '../../../base/ui/components/web/Button';
import ContextMenu from '../../../base/ui/components/web/ContextMenu';
import AccessiblePopover from '../../../inklusiva/accessiblePopover/accessiblePopover';
import { toggleCCHistoryPanel, toggleClosedCaptionPopup } from '../../actions.web';
import { getClosedCaptionVisibility } from '../../functions';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            background: 'none',
            display: 'inline-block'
        },
        buttonContainer: {
            position: 'relative',
            right: '50px',
            margin: 0,
            marginBottom: theme.spacing(1),
            maxHeight: 'calc(100vh - 100px)',
            overflow: 'auto',
            width: '300px'
        },
        button: {
            width: 'fit-content',
            background: 'none',
            marginBottom: '0.7rem',
            textAlign: 'left',
            paddingLeft: '10px',
            '&:hover': {
                backgroundColor: theme.palette.action03Hover
            }
        }
    };
});
/**
 * Popup with audio settings.
 *
 * @returns {ReactElement}
 */
function ClosedCaptionButtonPopup({ children, isOpen, onClickHistory, onClose, popupPlacement, _transcriptionHistory, _conferenceName, t }) {
    const { classes } = useStyles();
    const _onClickHistory = () => {
        onClickHistory();
    };
    const _onClickDownload = () => {
        const formattedMessages = _transcriptionHistory.map(message => {
            const { participantName, final } = message;
            const messageText = final;
            return `${participantName}: ${messageText}`;
        });
        const content = formattedMessages.join('\n');
        const element = document.createElement('a');
        const file = new Blob([content], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = `${_conferenceName}_transkript.txt`;
        document.body.appendChild(element); // Required for this to work in Firefox
        element.click();
    };
    let content = null;
    content = (React.createElement(ContextMenu, { "aria-labelledby": 'cc-settings-button', className: classes.buttonContainer, hidden: false, id: 'closed-caption-dialog', role: 'radiogroup', tabIndex: -1 },
        React.createElement(Button, { accessibilityLabel: t('toolbar.accessibilityLabel.ccHistory'), className: classes.button, icon: IconBubble, label: t('toolbar.ccHistory'), 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: _onClickHistory }),
        _transcriptionHistory.length > 0 && (React.createElement(Button, { accessibilityLabel: t('toolbar.accessibilityLabel.ccDownload'), className: classes.button, icon: IconDownload, label: t('toolbar.ccDownload'), 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: _onClickDownload }))));
    return (React.createElement("div", { className: classes.container },
        React.createElement(AccessiblePopover, { allowClick: true, content: content, headingId: 'cc-settings-button', onPopoverClose: onClose, position: popupPlacement, trigger: 'click', visible: isOpen }, children)));
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { clientWidth } = state['features/base/responsive-ui'];
    return {
        popupPlacement: clientWidth <= Number(SMALL_MOBILE_WIDTH) ? 'auto' : 'top-end',
        isOpen: Boolean(getClosedCaptionVisibility(state)),
        _transcriptionHistory: state['features/subtitles']._transcriptionHistory,
        _conferenceName: state['features/base/conference'].room ?? ''
    };
}
const mapDispatchToProps = {
    onClickHistory: toggleCCHistoryPanel,
    onClose: toggleClosedCaptionPopup
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(ClosedCaptionButtonPopup));
